import { Construction } from 'lucide-react';

// A thin amber strip warning that the page below is still being built. Rendered
// by a layout route above the page's own header when the active section is
// flagged `wip` in `frontends.ts` — so the notice is driven by the same source
// of truth as the sidebar's "WIP" badge and the two can never drift.
export default function WipBanner() {
    return (
        <div
            role="status"
            className="flex-none border-b border-[rgb(var(--color-rag-amber)/0.3)] bg-[rgb(var(--color-rag-amber)/0.08)] px-content-padding py-2"
        >
            <div className="max-w-content mx-auto flex items-center gap-2">
                <Construction className="h-4 w-4 flex-none text-[rgb(var(--color-rag-amber))]" />
                <span className="text-annotation font-medium text-[rgb(var(--color-rag-amber))]">
                    Work in progress — this page is not complete yet. The data and controls shown
                    here are placeholders.
                </span>
            </div>
        </div>
    );
}
